import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { MonitorRunPage } from '../../../../features/approvals/monitor/run-page'

export const Route = createFileRoute('/_app/workflows/runs/$runId')({
  staticData: { crumb: 'approvalRequest' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'workflows.runs'),
  component: MonitorRunPage,
})
